import { render, staticRenderFns } from "./PriceRuleEdit.vue?vue&type=template&id=e4405f1a&scoped=true"
import script from "./PriceRuleEdit.vue?vue&type=script&lang=ts"
export * from "./PriceRuleEdit.vue?vue&type=script&lang=ts"
import style0 from "./PriceRuleEdit.vue?vue&type=style&index=0&id=e4405f1a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4405f1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4405f1a')) {
      api.createRecord('e4405f1a', component.options)
    } else {
      api.reload('e4405f1a', component.options)
    }
    module.hot.accept("./PriceRuleEdit.vue?vue&type=template&id=e4405f1a&scoped=true", function () {
      api.rerender('e4405f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/price-rules/PriceRuleEdit.vue"
export default component.exports